import pMemoize from "@-/com.npmjs.p-memoize";
import type { ComponentType } from "react";
import type { WelcomeGalaxyCanvasProps } from "#welcome-galaxy-canvas-props";

/**
 * Web: CanvasKit (~7 MB of wasm) must be initialised before any Skia component module is
 * evaluated, so `LoadSkiaWeb` runs first and the scene is imported only afterwards. The binary is
 * served same-origin from `public/canvaskit/`; see `load-stats-timeline-chart-canvas.web.ts` for
 * why. Until it resolves, the welcome screen shows its text and buttons over plain black.
 */
export const loadWelcomeGalaxyCanvas = pMemoize(
  async (): Promise<ComponentType<WelcomeGalaxyCanvasProps>> => {
    const { LoadSkiaWeb } = await import("@-/com.npmjs.react-native-skia/web");
    await LoadSkiaWeb({ locateFile: (file: string) => `/canvaskit/${file}` });
    const { WelcomeGalaxyCanvas } = await import("#welcome-galaxy-canvas");
    return WelcomeGalaxyCanvas;
  },
);
